import { GBP_SYMBOL } from "lib/constants";
import { FC } from "react";
import { Card, Button, ListGroup } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
interface SubscriptionCardProps {
  isAddOn?: boolean;
  subscription: SubscriptionDetails;
  isEditable?: boolean;
  className?: string;
  onSubscribe?: () => void;
}

const SubscriptionCard: FC<SubscriptionCardProps> = ({
  subscription,
  isAddOn = false,
  isEditable = true,
  className,
  onSubscribe,
}) => {
  return (
    <Card className={`subscription-card shadow-lg rounded-4 w-100`}>
      {/* Subscription Title */}
      <Card.Header className="fw-bold text-center my-1 text-dark bg-white border-0">
        <Card.Title className="text-primary">
          <h3>{isAddOn ? "Add-On" : subscription.title}</h3>
        </Card.Title>
        <Card.Subtitle className="text-muted">
          <h6 style={{ fontSize: "12px" }}>{subscription.subTitle}</h6>
        </Card.Subtitle>
      </Card.Header>

      <Card.Body className={`d-flex flex-column flex-grow-1 pt-0 ${className}`}>
        {/* Price & Duration */}
        <div className="text-center">
          <h3 className="text-primary fw-normal">
            {GBP_SYMBOL}
            {subscription.perDayPrice}
          </h3>
          <p className="text-muted mb-3">Price Per Day</p>
        </div>

        {/* Description */}
        <p className="text-center" style={{ fontSize: "14px" }}>
          {subscription.description}
        </p>

        {/* Features List */}
        <ListGroup
          variant="flush"
          className="mb-3 d-flex flex-column align-items-center w-100"
          as="ul"
        >
          {subscription.features.map((feature) => {
            return (
              <ListGroup.Item
                key={feature.id}
                className="d-flex align-items-center w-100 text-center border-0"
              >
                <div className="d-flex align-items-center justify-content-center w-100">
                  {feature.isAvailable ? (
                    <FaCheckCircle className="text-success flex-shrink-0 me-2" />
                  ) : (
                    <MdCancel
                      className="text-danger flex-shrink-0 me-2"
                      size={20}
                    />
                  )}
                  <span className="text-start flex-grow-1">
                    {feature.label}
                  </span>
                </div>
              </ListGroup.Item>
            );
          })}
        </ListGroup>

        {/* Call to Action */}
        <div className="mt-auto">
          {subscription.notes && (
            <div className="d-flex justify-content-center align-items-baseline ms-2 mb-3">
              <h6 className="mx-2 d-flex align-items-center">
                Note <span className="ms-1">: </span>
              </h6>
              <p className="text-muted m-0" style={{ fontSize: "14px" }}>
                {subscription.notes}
              </p>
            </div>
          )}
        </div>
      </Card.Body>
      <Card.Footer className="border-0">
        {isEditable && (
          <Button
            variant="primary"
            className="w-100 rounded-pill fw-bold py-2"
            onClick={onSubscribe}
          >
            Subscribe Now
          </Button>
        )}
      </Card.Footer>
    </Card>
  );
};

export default SubscriptionCard;
